module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "rt-button",
    class: _vm.classes,
    attrs: {
      "disabled": _vm.buttonDisabled || _vm.loading,
      "autofocus": _vm.autofocus,
      "type": "button"
    },
    on: {
      "click": _vm.handleClick
    }
  }, [(_vm.isLoading) ? _c('i', {
    staticClass: "el-icon-loading"
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "rt-button-content"
  }, [(_vm.iconName) ? _c('rt-icon', {
    attrs: {
      "name": _vm.iconName,
      "size": _vm.iconSize
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasdefault) ? _c('span', {
    staticClass: "rt-button-text"
  }, [_vm._t("default")], 2) : _vm._e(), _vm._v(" "), (_vm.suffixIcon) ? _c('rt-icon', {
    attrs: {
      "name": _vm.suffixIcon,
      "size": _vm.iconSize
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cff2f98"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/button/rtButton.vue
// module id = 1519
// module chunks = 124